<template>
	<div v-bottom="nextPage" class="run">
		<div v-for="(item,index) in aiRecords" :key="index">
			<p class="head flex between">
				<span>{{item.dateAndWeek}}</span>
				<span>
					运动次数:
					<span>{{item.log?.length}}次</span>
				</span>
			</p>
			<div v-for="(record,indexItem) in item.log" :key="'r'+indexItem" class="card flex between">
				<div>
					<p class="text-ellipsis">{{record.name}}</p>
					<p>训练时长：{{record.duration}}</p>
				</div>
				<span>{{record.score}}</span>
			</div>
		</div>
		<!-- <div v-if="endPage" class="scroll-end"></div> -->
	</div>
</template>

<script>
import { getWeek } from "@/utils/date.js";
function queryParams() {
	return{
		teamId:undefined,
		pageNo:1,
		pageSize:10,
	}
}
export default {
	props: {
		currentTab: {},
	},
	data() {
		return {
			params: queryParams(),
			pages:0,
			aiRecords:[]
		};
	},
	computed: {
		endPage() {
			return this.pages && this.pages == this.params.pageNo;
		},
	},
	watch: {
		currentTab: {
			handler(newVal) {
				if (newVal === 1) {
					this.params = queryParams();
					this.getAiRecords();
				}
			},
			immediate: true,
		},
	},
	methods:{
		nextPage() {
			if (this.endPage) return;
			this.params.pageNo++;
			this.getAiRecords();
		},
		async getAiRecords() {
			this.params.teamId = this.$route.query.gradeId;
			try {
				const {success,message,result} = await this.$http.get(`h5/exerciseLog/listAi`,{params:this.params});
				if(!success) throw new Error(message);
				this.pages = result.pages;
				result.records.forEach(item => {
					item.dateAndWeek = item.motionTime.split(" ")[0] + " " + getWeek(item.motionTime);
				});
				this.aiRecords = result.records;
			} catch (error) {
				console.log("getAiRecords", error?.message);
			}
		},
	}
};
</script>

<style scoped lang="less">
.run {
	height: 100%;
	padding: 10/@rem 17 / @rem;
	overflow-y: auto;
	background-color: rgba(255, 185, 0, 0.6);

	.card {
		height: 66 / @rem;
		padding: 12 / @rem 15 / @rem;
		margin-bottom: 11 / @rem;
		background: #ffffff;
		box-shadow: 0 3 / @rem 17 / @rem 0 rgba(143, 72, 0, 0.2);
		border-radius: 12 / @rem;
		> div {
			flex: 1;
			overflow: hidden;
			p {
				width: 100%;
				&:first-child {
					font-size: 17 / @rem;
					font-weight: bold;
				}
				&:last-child {
					color: rgba(31, 30, 29, 0.6);
				}
			}
		}
		> span {
			min-width: 65/@rem;
			text-align: right;
			font-size: 23 / @rem;
			font-weight: bold;
			color: rgba(255, 162, 22, 1);
			&::after {
				content: "分";
				padding-left: 2 / @rem;
				font-size: 10 / @rem;
				color: rgba(31, 30, 29, 1);
			}
		}
	}
	p.head {
		padding: 12 / @rem 0 12/@rem;
		font-size: 10 / @rem;
		color: white;
		span span {
			font-size: 12 / @rem;
		}
	}
}
</style>
